import React from 'react';
import { FaGavel } from 'react-icons/fa';
import DepartamentoPedidosPage from './DepartamentoPedidosPage';

const ComissoesPage = () => (
  <DepartamentoPedidosPage
    departamentoId="comissoes"
    titulo="Comissões da OAB/MS"
    nomeEmptyState="Comissões"
    Icon={FaGavel}
  />
);

export default ComissoesPage;
